export default __webpack_public_path__ + "static/media/play.5e4d14b4.png";